module.exports = __webpack_public_path__ + "static/media/logoNav.205d3c4a.png";